export const ProjectData=[
    {
            id:1,
            title:'CoinZest',
            about:"This is backed React Native app for the CryptoCurrency database dataset.",
            tags:["React Native","NodeJs","JavaScript"],
            github:"https://github.com/romit0226/CoinZest",
            demo:"https://github.com/romit0226/CoinZest",
            image:"https://lh4.googleusercontent.com/o9uO2Ca3UDAyJuGDzXmQyvFMRltmqVpw9ZaYSOX5DWtoQDMbPD8PkB-n4kV0cPju4bWAkpw5LdEqjrTksDeRNbWsBdZopOVwSFw6MgpDbzsw_MenB7L3Trd6A3SQODdHP0BPPSPS",


    },

]